var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnemy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5744 34.8327L29.5782 4.36796C28.8162 3.04604 27.6096 2.12269 26.1422 2.03434C24.6749 1.946 23.1565 2.70528 22.4511 3.93886L3.90803 32.3842C2.993 33.6052 2.89093 35.3004 3.65286 36.6224C4.20517 37.9317 5.62148 38.8676 7.08882 38.956L40.6281 40.9753C42.0954 41.0637 43.6138 40.3044 44.3192 39.0708C45.2343 37.8498 45.3363 36.1546 44.5744 34.8327ZM23.0071 15.6695C23.0836 14.398 24.1955 13.4016 25.4533 13.4773C26.711 13.553 27.6953 14.6757 27.6187 15.9471L27.0574 25.271C26.9808 26.5424 25.8689 27.5389 24.6112 27.4632C23.3535 27.3874 22.3692 26.2648 22.4457 24.9933L23.0071 15.6695ZM24.1136 35.7275C22.0174 35.6013 21.713 33.6689 21.764 32.8213C21.8151 31.9737 22.3491 30.0917 24.4453 30.2179C26.5415 30.3441 26.846 32.2766 26.7949 33.1242C26.7439 33.9718 26.2098 35.8537 24.1136 35.7275Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.896362,
    y: 0.772263,
    width: 48.2078,
    height: 44.4555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnemy);
export default __webpack_public_path__ + "static/media/enemy.09f58807.svg";
export { ForwardRef as ReactComponent };